import React, { useContext, useEffect, useRef, useState } from 'react'
import { IEnquiryDetail } from '../../../models/Enquiry'
import { onKeyPressHandler } from '../../../utilities/commonFunctions'
import Conditional from '../../common/Conditional'
import FormDependencyLoaderContext from '../../context/FormDependencyLoaderContext'
import EnquiryContext from '../context/EnquiryContext'
import EnquiryDefaultDetail from './EnquiryDefaultDetail'
import EnquiryRequestForInformationTable from './EnquiryRequestForInformationTable'

export interface IEnquiryDefaultProps {
  clearErrors: () => void
  handleErrors?: (any) => void
}

const EnquiryDefault = (props: IEnquiryDefaultProps) => {
  const mountedRef = useRef(false)
  const tableComponent = useRef(null)
  const context = useContext(EnquiryContext)
  const formDependencyContext = useContext(FormDependencyLoaderContext)
  const [isLoading, setIsLoading] = useState(true)
  const [toggleState, setToggleState] = useState(1)
  const [data, setData] = useState<IEnquiryDetail>()
  const toggleTab = (index) => {
    if (tableComponent.current) {
      tableComponent.current.clear()
    }
    setToggleState(index)
    props.clearErrors()
  }

  useEffect(() => {
    mountedRef.current = true
    formDependencyContext.show()
    if (mountedRef.current) {
      setData(context.enquiry)
      setIsLoading(false)
      formDependencyContext.hide()
    }
    return () => {
      mountedRef.current = false
    }
  }, [context.enquiry])

  return (
    <Conditional if={!isLoading && data}>
      <h2>Enquiry details</h2>
      <h3>Enquiry number: {data?.number}</h3>

      <div className="tabs js-tabs">
        <div className="tab-selections" role="tablist">
          <button
            data-tab-target="tab-1"
            className={toggleState === 1 ? 'button is-active' : 'button'}
            onClick={() => toggleTab(1)}
            onKeyPress={onKeyPressHandler}
            role="tab"
          >
            Enquiry details
          </button>
          <Conditional if={data?.requestInformation?.length > 0}>
            <button
              data-tab-target="tab-2"
              className={toggleState === 2 ? 'button is-active' : 'button'}
              onClick={() => toggleTab(2)}
              onKeyPress={onKeyPressHandler}
              role="tab"
            >
              Request for information
            </button>
          </Conditional>
        </div>
        <div className="tab-content">
          <div className={toggleState === 1 ? 'tab-1 is-active' : 'tab-1'}>
            <EnquiryDefaultDetail data={data} />
          </div>
          <Conditional if={data?.requestInformation?.length > 0}>
            <div className={toggleState === 2 ? 'tab-2 is-active' : 'tab-2'}>
              <EnquiryRequestForInformationTable
                ref={tableComponent}
                data={data?.requestInformation}
                handleErrors={props.handleErrors}
              />
            </div>
          </Conditional>
        </div>
      </div>
    </Conditional>
  )
}
export default EnquiryDefault
